import React from "react";
import { Link } from "react-router-dom";
import { PackageX } from "lucide-react";
import { Button } from "./ui/button";

/**
 * Fase 3 · Catalog kill-switch — banner mostrado por las páginas de la
 * tienda `/envio` y `/local` cuando el admin ha ocultado el catálogo. Se
 * consume tanto vía `useShop().catalog_hidden` (contexto compartido) como
 * a través del header `X-Catalog-Hidden` que devuelven los endpoints
 * públicos de productos.
 */
export default function CatalogHiddenBanner() {
  return (
    <section
      data-testid="shop-catalog-unavailable-banner"
      className="mx-auto my-16 max-w-2xl rounded-3xl border-2 border-dashed border-amber-300 bg-amber-50 px-6 py-12 text-center"
    >
      <div className="mx-auto mb-4 grid h-16 w-16 place-items-center rounded-full bg-white shadow-inner">
        <PackageX className="h-8 w-8 text-amber-600" />
      </div>
      <h2 className="text-2xl font-black tracking-tight text-neutral-900">
        Catálogo temporalmente no disponible
      </h2>
      <p className="mt-2 text-sm text-neutral-600">
        Estamos actualizando nuestros productos. Vuelve pronto para completar
        tu pedido.
      </p>
      <div className="mt-6 flex items-center justify-center gap-3">
        <Button asChild variant="outline" className="rounded-full">
          <Link to="/" data-testid="shop-catalog-back-home">
            Volver al inicio
          </Link>
        </Button>
        <Button asChild className="rounded-full bg-emerald-600 hover:bg-emerald-700 text-white">
          <Link to="/enviar-paquete/nuevo" data-testid="shop-catalog-cta-paquete">
            Enviar un paquete
          </Link>
        </Button>
      </div>
    </section>
  );
}
